module.exports = __webpack_public_path__ + "static/notification-error-4cd50a39a79702723f1560bad2f92b1e.png";